import React from 'react';

import { Link } from 'gatsby';

import '../../styles/essays/index-sidebar.scss';

const IndexSidebar = ({ paragraph, indexItems }) => {
    const filteredIndexItems = indexItems.filter(item => item.paragraphRef === paragraph);

    if (filteredIndexItems.length === 0) {
        return null;
    }

    return (
        <div className="index-sidebar-block" id={`index-sidebar-${paragraph}`}>
            <div className="index-sidebar-contents">
                <div className="index-sidebar-header">
                    <span className="reference-mark">※</span>
                    <span className="label">Indexed under…</span>
                </div>
                <ul className="index-listings">
                    {filteredIndexItems.map(item => (
                        <li className="index-note">
                            <span
                                className="category-label"
                            >
                                {item.categoryLabel}
                            </span>
                            <Link
                                to={`/explore/indexed#${item.categorySlug}-${item.listingSlug}`}
                                className="listing-label"
                            >
                                {item.listingLabel}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default IndexSidebar;
